<template>
  <div>
    <div class="columns is-multiline">
      <div class="column is-half">
        <div class="box">
          <admin-box-item title="견적서 템플릿 목록"
                          :useTab="false">
            <div style="overflow-y: auto">
              <div style="height: 450px">
                <li v-for="(item, idx) in items" v-bind:key="'item'+idx">
                  <div class="lp-cat-item">
                    <div>{{ item.name }}</div>
                    <div style="flex:1"></div>
                    <button class="button half" @click.stop.prevent="selectItem(item)" style="margin-right:4px" v-if="item.id>0">수정</button>
                    <button class="button half is-danger" @click="delItem(items, idx)">삭제</button>
                  </div>
                </li>
              </div>
            </div>
            <div class="btn-add-category" @click="addItem">+ 옵션 추가</div>
          </admin-box-item>
        </div>
      </div>

      <div class="column is-half" v-if="selectedItem">
        <div class="box">
          <admin-box-item title="옵션 추가/수정">
            <admin-form-item label="템플릿명*">
              <input class="input"
                     placeholder="(템플릿명)"
                     :value="selectedItem.name"
                     @input="e => selectedItem.name = e.target.value">
            </admin-form-item>

            <div class="flex-align edit-label-button unselect">
              <i class="material-icons" style="font-size:18px">edit</i>
              <div style="margin-left: 2px;font-size:12px" @click="$modal.show('editLabelModal')">라벨 편집</div>
            </div>

            <div class="columns is-multiline"
                 v-for="(item, idx) in selectedItem.price_info" :key="idx">
              <div class="column is-3">
                <admin-form-item :label="item.note_label">
                  <input class="input"
                         :value="item.note"
                         @input="e => item.note = e.target.value">
                </admin-form-item>
              </div>
              <div class="column is-3">
                <admin-form-item :label="item.unit_price_label">
                  <input class="input"
                         :value="item.unit_price"
                         @input="e => item.unit_price = parseInt(e.target.value)"
                         type="number">
                </admin-form-item>
              </div>
              <div class="column is-3">
                <admin-form-item :label="item.quantity_label">
                  <input class="input"
                         :value="item.quantity"
                         @input="e => item.quantity = parseInt(e.target.value)"
                         type="number">
                </admin-form-item>
              </div>
              <div class="column is-3">
                <admin-form-item :label="item.price_label">
                  <div class="flex-center">
                    <input class="input"
                           :value="item.price"
                           @input="e => item.price = parseInt(e.target.value)"
                           type="number">
                    <i class="material-icons unselect" @click="removeIndex(selectedItem.price_info,idx)">close</i>
                  </div>
                </admin-form-item>
              </div>
            </div>
            <div style="margin-top:20px;justify-content: center;display:flex">
              <div @click="addPrice"><i class="fa fa-plus" aria-hidden="true"></i></div>
            </div>
          </admin-box-item>
        </div>

        <div class="btn-group-justify-end">
          <button class="button" style="margin-right:4px" @click="selectedItem=undefined">취소</button>
          <button class="button is-primary" @click="modifyItem">저장하기</button>
        </div>
      </div>
    </div>

    <modal name="editLabelModal" :adaptive="true" :width="311" height="auto" class="modal-style">
      <div class="lp-modal-wrapper">
        <admin-form-item label="내용">
          <input class="input"
                 :value="selectedLabel.note_label"
                 @input="e => selectedLabel.note_label = e.target.value"
                 type="text">
        </admin-form-item>
        <admin-form-item label="단가">
          <input class="input"
                 :value="selectedLabel.unit_price_label"
                 @input="e => selectedLabel.unit_price_label = e.target.value"
                 type="text">
        </admin-form-item>
        <admin-form-item label="수량">
          <input class="input"
                 :value="selectedLabel.quantity_label"
                 @input="e => selectedLabel.quantity_label= e.target.value"
                 type="text">
        </admin-form-item>
        <admin-form-item label="금액">
          <input class="input"
                 :value="selectedLabel.price_label"
                 @input="e => selectedLabel.price_label = e.target.value"
                 type="text">
        </admin-form-item>
        <div class="btn-group-justify-end">
          <button class="button is-light" @click="$modal.hide('editLabelModal')">취소</button>
          <button class="button is-primary" @click="saveLabel">저장하기</button>
        </div>
      </div>
    </modal>
  </div>
</template>

<script>
  import draggable from 'vuedraggable'
  import BreadCrumb from '../../module/common/BreadCrumb'
  import InputImg from "../../module/common/InputImg";
  import LpDropdown from "../../module/common/LpDropdown";
  import LpInputText from "../../module/common/LpInputText";
  import AdminFormItem from "../../module/admin/AdminFormItem";

  export default {
    name: 'estimate-template',
    components: {
      AdminFormItem,
      LpInputText,
      LpDropdown,
      InputImg,
      draggable,
      BreadCrumb
    },
    created() {
      this.getTemplateList();
    },
    data() {
      return {
        items: [],
        selectedItem: undefined,
        selectedLabel: {
          note_label: '',
          unit_price_label: '',
          quantity_label: '',
          price_label: ''
        }
      }
    },
    methods: {
      saveLabel() {
        let err = '';
        if(this.selectedLabel.note_label==='') {
          err = '라벨 내용을'
        }
        else if(this.selectedLabel.unit_price_label==='') {
          err = '라벨 단가를'
        }
        else if(this.selectedLabel.quantity_label==='') {
          err = '라벨 수량을'
        }
        else if(this.selectedLabel.price_label==='') {
          err = '라벨 금액을'
        }
        if (err) {
          this.toast(err + ' 입력하세요.');
          return;
        }


        let price_info = [];
        for(let i=0; i<this.selectedItem.price_info.length; i++) {
          let item = this.selectedItem.price_info[i];
          price_info.push(Object.assign({}, item, this.selectedLabel));
        }
        this.selectedItem.price_info = price_info;
        this.$modal.hide('editLabelModal');
      },
      // 템플릿 수정
      modifyItem () {
        let errMsg = '';
        if(!this.selectedItem.name) {
          errMsg = '템플릿명을 입력해주세요.';
        }
        let items = this.selectedItem.price_info;
        for(let i=0; i<items.length; i++) {
          if(!items[i].note) {
            errMsg = '상세 내용을 입력해주세요.';
            break;
          }
        }
        if(errMsg) {
          this.toast(errMsg);
          return;
        }

        this.$axios.patch(this.getUrl(`estimate/template/${this.selectedItem.id}`), {
          template: this.selectedItem
        }).then(res => {
          if(res.status===200) {
            this.toast('저장되었습니다.');
            this.selectedItem=undefined;
            this.getTemplateList();
          }
        })
      },
      // 템플릿 선택
      selectItem (item) {
        this.selectedItem = item;

        if(this.selectedItem.price_info.length>0) {
          let selectedLabel = this.cloneItem(this.selectedItem.price_info[0]);
          this.selectedLabel = {
            note_label: selectedLabel.note_label,
            unit_price_label: selectedLabel.unit_price_label,
            quantity_label: selectedLabel.quantity_label,
            price_label: selectedLabel.price_label
          }
        }
        else {
          this.selectedLabel = {
            note_label: '내용',
            unit_price_label: '단가',
            quantity_label: '수량',
            price_label: '금액'
          }
        }
      },
      // 템플릿 목록
      getTemplateList () {
        this.$axios.get(this.getUrl('estimate/template')).then(res => {
          this.items = res.data;
        })
      },
      saveData (type) {
        this.$axios.post(this.getUrl(`estimate/template`), {
          templates: this.items
        }).then(res => {
          if(res.status===200) {
            if(type==='add') this.toast('새 옵션을 추가했습니다.');
            else this.toast('저장되었습니다.');
            this.getTemplateList();
          }
        })
      },
      // 템플릿 추가
      addItem () {
        this.items.push({
          id: 0,
          name: '(템플릿명)',
          price_info: [
            {
              note_label: '내용',
              unit_price_label: '단가',
              quantity_label: '수량',
              price_label: '금액',
              note: '내용을 입력하세요.',
              unit_price: '',
              quantity: '',
              price: ''}
          ]
        })
        this.saveData('add');
      },
      delItem (items, idx) {
        if(items[idx].id===0) {
          removeIndex(items, idx);
        }
        else {
          this.$axios.delete(this.getUrl('estimate/template/'+items[idx].id))
            .then(res => {
              if(res.status===200) {
                this.toast('옵션이 삭제되었습니다.');
                removeIndex(items, idx);
              }
            });
        }
      },
      // 견적서 상세 금액 항목 추가
      addPrice() {
        if (this.selectedLabel.note_label === '' ||
          this.selectedLabel.unit_price_label === '' ||
          this.selectedLabel.quantity_label === '' ||
          this.selectedLabel.price_label === '') {
          this.toast('라벨 편집 후 추가하세요.');
          return;
        }

        let item = {
          note: '',
          price: '',
          unit_price: '',
          quantity: ''
        }
        this.selectedItem.price_info.push(Object.assign({}, item, this.selectedLabel));
      },
    }
  }
</script>

<style lang="styl" type="stylus" scoped>
  //@import '~assets/css/lp_main'
  li
    list-style-type none
    list-style none

  .div-category
    margin-right 20px
    width 500px

  .box-category
    box-sizing border-box
    padding 20px
    background-color white
    overflow-y auto
    max-height 500px

  .lp-row-title
    color #064160
    font-size 1.1rem
    border-bottom 1px solid #555
    padding-bottom 8px
    margin-bottom 20px

  .lp-total-title
    color #064160
    font-size 0.9rem
    margin auto 0

  .ghost
    opacity .5
    background-color #c8ebfb

  .dragArea
    padding 5px 0
    padding-left 20px

  /*min-height 20px*/

  .div-count
    border-radius 30px
    background-color #555
    color white
    font-size 0.7rem
    text-align center
    margin-left 8px
    width 18px
    height 18px
    line-height 18px

  .lp-cat-item-total
    box-sizing border-box
    display flex
    justify-content space-between
    margin-top 20px
    margin-bottom 8px
    padding 12px 8px
    width 100%
    background-color #eceeef
    color #555
    font-size 0.9rem

  .lp-cat-item
    font-size 0.9rem
    border 1px solid #ccc
    padding 8px
    display flex
    margin-bottom 8px

  .lp-cat-item div
    margin auto 0
    margin-right 8px

  .lp-cat-item div:last-child
    margin-right 0

  .btn-add-category
    padding 12px
    text-align center
    border 1px solid #ccc
    font-size 0.9rem

  label
    color #064160
    font-size 0.8rem

  .lp-content input
    margin-top 4px
    margin-left 8px
    border 0
    padding 4px 12px
    background #f2f6f8
    font-size 0.9rem

  .lp-cat-btn
    color #787878
    border 1px solid #787878
    margin-top 16px
    margin-right 8px
    border-radius 3px
    padding 4px 20px
    font-size 0.9rem
    text-align center
    display inline-block

  .lp-cat-btn.select
    border 1px solid $primary
    color $primary

  .btn-update
    margin-bottom 0

  .edit-label-button
    width 72px
    background-color #eee
    border 1px solid
    border-radius 4px
    padding 2px 0
    margin 12px 0
</style>
